import { useNavigate } from 'react-router-dom';
import { Helpers } from '../../../utils/helpers';
import { SystemCodeLookup } from '../../../components/systemCode/SystemCodeLookup/SystemCodeLookup';
import { SystemCodeEditor } from '../SystemCodeEditor/SystemCodeEditor';
import useSystemCodeSearch from './useSystemCodeSearch';

export const SystemCodeSearch = () => {
  const navigate = useNavigate();
  const manager = useSystemCodeSearch();

  return (
    <>
      {Helpers.isNullOrWhiteSpace(manager.systemCodeId) && (
        <div className="page-container mt-2">
          <div className="text-end">
            <button className="btn btn-primary" onClick={() => navigate(`/codes/new`)}>
              Add Code
            </button>
          </div>
          <SystemCodeLookup
            systemCodeId={manager.systemCodeId}
            onChange={manager.systemCodeSelected}
          />
        </div>
      )}
      <SystemCodeEditor systemCodeId={manager.systemCodeId} />
    </>
  );
};
